export enum ViewEnum {
    chose = 0,
    create = 1,
    review = 2,
    close = 3,
}
